define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "다른 사용자 등록",

    'incrowd_stats.num_responders': "{{num}} 의료 전문가",
    'incrowd_stats.num_answers': "{{num}} 답변한 질문",
    'incrowd_stats.time_to_complete': "{{num}} 분 - 평균 설문 조사 완료",

    // INCROWD
    'incrowd.about': "소개",
    'incrowd.contact': "문의",
    'incrowd.press': "언론",
    'incrowd.careers': "채용",
    'incrowd.terms': "약관",
    'incrowd.t_and_c': "사용 약관",
    'incrowd.faq': "자주 묻는 질문",
    'incrowd.privacy': "개인 정보",
    'incrowd.copyright': "{{year}} InCrowd Inc, All Rights Reserved",
    'incrowd.blog': "블로그",
    'incrowd.support': "지원",
    'incrowd.info.ios': "이제 InCrowd 네트워크에서 의사들이 자신의 동료들에게 직접 질문을 보낼 수 있다는 사실을 알고 계셨나요 ​​? 지금 <InCrowd iOS App>을 사용하여 경험해 보십시오!",
    'incrowd.refer': "당사의 설문 조사에 만족하셨나요? 오늘 <친구를 추천>하여 당사 크라우드에 가입하시면 귀하와 추천 친구 모두 10달러(또는 등가물)를 적립할 수 있습니다. 동료가 설문 조사에 응답하면, 보너스가 주어집니다!",

    // GET STARTED (step 0)
    'getstarted.encourage.title': "마이크로서베이,",
    'getstarted.encourage.title.two': "거대한 영향",
    'getstarted.encourage.subtitle': "간단한 마이크로서베이를 통해 세 제품과 환자 치료 개발에 영향을 미치는 자격을 갖춘 수천 명의 의료 전문가와 합류하고, 우리가 당신에게도 지불할 것입니다!",
    'getstarted.encourage.redirect_to_solutions': "전문 의료진은 아니지만 InCrowd에 대해서 더 알고 싶으십니까?",
    'getstarted.actions.title': "자격있는 의료 전문가입니까?",
    'getstarted.actions.subtitle': "오늘 가입 및 마이크로서베이에 중점을 둔 의료 서비스에 답변하여 돈을 적립하기 시작",
    'getstarted.button.continue': "시작하기",
    'getstarted.referral': "설문 조사와 %{{referrerName}} 소개 보너스로 돈을 적립하려면 등록하세요",
    'getstarted.register_with.register_with': "다음으로 등록",
    'getstarted.register_with.email': "또는 이메일로",

    'details.need_info_description': "계정을 설정하려면 몇 가지 세부 정보가 필요합니다.",
    'details.profile_details': "프로필 세부 정보",
    'details.address_information': "주소 정보",
    'details.professional_info': "전문 정보",
    'details.heading.finally': "…그리고 마침내",
    'details.how_receive_surveys': "설문 조사를 어떻게 수신하고자 하십니까?",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "기초",
    'professionchoice.encourage.subtitle': "전문의를 보지 않았습니까? Let us know <여기>에 우리에게 알려 우리가 사용자의 전문의를 추가할 경우 알림을 받도록 보장합니다.",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "누구십니까?",
    'authentication.encourage.subtitle': "InCrowd는 사용자의 ID를 인증해야 하지만, 제 3자에게 개인 정보를 절대로 밝히거나 배포하지 않습니다.",
    'authentication.actions.select_notifications': "우리로부터 설문 조사를 받고자 하는 방법 선택",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "정보를 확인하는 동안 잠시 동안 기다려주십시오.",
    'validation.please_answer': "개인 정보를 확인하도록 돕기 위해, 다음과 같은 질문에 답변하십시오.",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "확인",
    'confirmation.validation_success.subtitle': "등록이 완료되었습니다. InCrowd 에 오신 걸 환영합니다! 이메일 및/또는 문자 메시지를 통해 곧 확인 메시지를 수신하게 됩니다. 합류해 주셔서 감사합니다!",
    'confirmation.validation_error.title': "필요한 추가 정보",
    'confirmation.validation_error.subtitle': "%{userFirstName}, 죄송합니다. 개인 세부 정보를 확인하는 문제가 발생했습니다.",
    'confirmation.actions_title': "다음 단계는 무엇입니까?",
    'confirmation.go_to_your_profile': "프로필로 이동",
    'confirmation.validation_success.actions_subtitle': "이틀 후 5-10 분 짜리 작은 설문 조사를 이메일 또는 텍스트 메시지로 받게 될 겁니다. 텍스트 메시지 설문 조사 받기를 아직 선택 안 하셨습니까? 언제든지 당신 InCrowd 프로필에서 통신 설정을 변경할 수 있습니다.",
    'confirmation.validation_error.actions_subtitle': "InCrowd 팀 구성원들과 상담하고 모든 문제를 해결하기 위해, 화면 오른쪽 아래에 있는 팝업 채팅을 사용하십시오.",
    'confirmation.referral.info.1': "당신과 당신을 소개한 사람이 두 번째 설문 조사를 완료하면 %{payoutBusinessDays} 업무일 내에 <%{currency}%{referralBonusAmount}를 각각 받게 됩니다>. %{currency}%{referralBonusAmount}는 당신 보상 계정으로 들어갑니다. 당신은 언제든지 <프로필>로 들어가서 선호 업데이트, 보상 보기, 초대 받은 설문 조사 열기를 할 수 있습니다. ",
    'confirmation.referral.info.2': "질문? <우리와 채팅>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "자격이 있습니까?",
    'regftr.markets.accepting': "현재 InCrowd 답변은 수락 중입니다:",
    'regftr.peers.title': "피어",
    'regftr.peers.subtitle': "사용자의 응답과 피어로부터의 답변을 비교하고 해당 답변에서 배웁니다.",
    'regftr.invites.title': "초대",
    'regftr.invites.subtitle': "이메일이나 휴대폰을 통해 새로운 설문 조사 초대를 받아 적립금을 극대화합니다.",
    'regftr.earnings.title': "적립금",
    'regftr.earnings.subtitle': "적립금과 결제 정보를 관리하고 추적합니다.",
    'regftr.stats.title': "통계",
    'regftr.stats.subtitle': "모든 설문 조사 정보와 사용자 세부 정보가 있는 대시보드에 액세스합니다.",

    'contextual_help.sms': "열린 마이크로 설문 조사에 대한 문자 메시지를 받게 될 겁니다. 귀하는 문자를 통해 더 빨리 설문 조사에 응할 수 있고 보상도 더 받을 수 있습니다. 귀하 정보는 설문 조사 요청 목적으로만 사용됩니다.",
    'contextual_help.specialty': "귀하의 NPI와 연결된 전문 분야, 귀하의 일차 전문 분야에서 수료한 펠로우십이나 의료 분야만 기재하여 주십시오. 전문 분야 변경을 원하시면 support@incrowdnow.com으로 문의하십시오.",
    // USER
    'user(s)': "사용자 |||| 사용자",
    'user.login': "로그인",
    'user.logout': "로그아웃",
    'user.register': "등록",
    'user.invitations': "초대",
    'user.email': "이메일",
    'user.pass_word': "암호",
    'user.mobile': "모바일",
    'user.mobile.hint': "국가 코드 포함 필요(+%{phoneCode}, %{countryName})",
    'user.title': "제목",
    'user.title_with_example': "호칭(예: Dr., Ms., Mr)",
    'user.first_name': "이름",
    'user.last_name': "성",
    'user.middle_name': "중간 이름",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "사용자",
    'user.anonymous_admin': "사용자 관리",
    'user.dashboard': "대시보드",
    'user.profile': "프로필",
    'user.profile.picture.upload': "프로필 사진 업로드",
    'user.profile.picture.change': "변경",
    'user.primary_lang': "주요 언어",
    'user.primary_lang?': "주요 언어는 무엇입니까?",
    'user.survey_langs?': "어떤 언어를 능숙하게 말할 수 있습니까?",
    'user.notify_email': "이메일로 알림",
    'user.notify_mobile': "모바일로 알림",
    'user.contact_support': "지원 문의",
    // SATURN-9
    'user.contact_trouble': "문제가 있으신가요? 아래 연락처로 문의하십시오.",
    'user.contact_email': "당사에 이메일 보내기",
    // end SATURN-9
    'user.please_contact_us': "<당사에 문의>하십시오.",
    'user.profession': "직업",
    'user.profession?': "사용자의 직업은 무엇입니까?",
    'user.join_now': "지금 가입",
    'user.welcome_back': "다시 오신 걸 환영합니다!",
    'user.not_a_member?': "아직 회원이 아니신가요?",
    'user.accept_terms': "약관 동의",
    'user.accept_terms.yes': "<사용 약관>에 동의함",
    'user.remember_me': "이 장치에서 나를 기억",
    'user.time_zone': "시간대",
    'user.payment.policy': "귀하는 매번 보상으로 %{currency}25을 받을 때마다 알림을 받고 InCrowd 프로필에서 지불 옵션 중 하나를 선택할 수 있습니다. 질문 있으세요? 아래 대화창에 문의하십시오.",
    'user.country.live_work?': "거주 및 근무하시는 나라는 어디입니까?",
    // FORMS
    'form.button.back': "뒤로",
    'form.button.next': "다음",
    'form.button.cancel': "취소",
    'form.button.submit': "제출",
    'form.button.continue': "계속",
    'form.button.close': "닫기",
    'form.button.go!': "이동!",
    'form.button.complete!': "지금 완료했습니다!",
    'form.button.update': "업데이트",
    'form.button.finish': "마침",
    'form.button.search': "검색",
    'form.button.end': "종료",
    'form.search.no_matches': "일치하는 항목 없음",
    'form.confirm_email': "이메일 확인",
    'form.confirm_pass_word': "암호 확인",
    'form.required_fields': "필수 필드",
    'form.nothing_selected': "선택한 사항 없음",
    'form.confirm_field': "%{formFieldLabel} 확인",
    'form.choice.n/a': "해당사항없음",
    'form.choice.yes': "예",
    'form.choice.no': "아니요",
    'form.choice.blank_for_all': "공란으로 비워 모두 선택",
    'form.choices.select_all': "모두 선택",
    'form.choices.deselect_all': "모두 선택 해제",
    'form.field.private': "개인 정보 필드",

    // USER ERRORS
    'user.error.dup_email': "다른 사용자가 이미 등록한 이메일 주소입니다. <대신 로그인 하시겠습니까?>",
    'user.error.dup_sms': "다른 사용자가 이미 주어진 모바일 번호로 등록했음",

  }
})
